import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AutosizeInput from 'react-input-autosize';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import classNames from 'classnames';
import { buttonClicked } from '../../actions/button-clicked';
import ProfileCover from '../../components/profile-cover';
import ProfilePhoto from '../../components/profile-photo';
import ProfileStats from '../profile-stats';
import UploadImageButton from '../../components/upload-image-button';
import UserBadge from '../../components/user-badge';
import { SecondaryEditIcon } from '../../components/icons';
import profileFormSettings, { NAME_MAX_LENGTH } from '../../services/profile-form-settings';
import resolveUserImage from '../../services/resolve-user-image';
import isDataUrl from '../../services/is-data-url';
import { getFollowersCount, getFollowingCount, getPostsCount } from '../../services/counters';
import withTranslate from '../../hoc/with-translate';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './profile.scss';

export const VIEW_PROFILE = 'VIEW_PROFILE';
export const VIEW_PROFILE_EDIT = 'VIEW_PROFILE_EDIT';

const VIEW_CLASS_NAMES = {
  [VIEW_PROFILE]: styles.viewProfile,
  [VIEW_PROFILE_EDIT]: styles.viewProfileEdit,
};

class Profile extends Component {
  isProfile() {
    return this.props.view === VIEW_PROFILE;
  }

  isProfileEdit() {
    return this.props.view === VIEW_PROFILE_EDIT;
  }

  handleButtonClicked = name => () => this.props.buttonClicked({ name });

  renderUploadCoverButton() {
    return (
      this.isProfileEdit() &&
      <UploadImageButton
        onClick={this.handleButtonClicked('change_cover_photo_click')}
        className={classNames(styles.uploadCoverButton, 'profile__upload-cover-button')}
        onChange={this.props.onCoverChange}
      />
    );
  }

  renderUploadPhotoButton() {
    return (
      this.isProfileEdit() &&
      <UploadImageButton
        onClick={this.handleButtonClicked('change_avatar_click')}
        className={classNames(styles.uploadPhotoButton, 'profile__upload-photo-button')}
        onChange={this.props.onImageChange}
      />
    );
  }

  renderName() {
    const { value, onChange: handleChange } = this.props.fields.name;

    if (this.isProfileEdit()) {
      return (
        <div className={styles.nameFieldWrapper}>
          <SecondaryEditIcon className={classNames(styles.editIcon, 'forum-icon-fill')}/>
          <AutosizeInput
            className={styles.nameField}
            inputClassName={classNames(styles.nameInput, 'forum-text-color', 'profile__name-input')}
            value={value}
            maxLength={NAME_MAX_LENGTH}
            onChange={handleChange}
            data-hook="profile__name-input"
          />
        </div>
      );
    }

    return value;
  }

  renderBadge = () => <UserBadge user={this.props.user}/>;

  renderJoinDate() {
    const { t } = this.props;
    return (
      this.isProfile() &&
      <div className={styles.date}>
        {t('profile.joined', { date: this.props.user.createdDate })}
      </div>
    );
  }

  renderStats() {
    return (
      this.isProfile() &&
      <div className={styles.statsContainer}>
        <ProfileStats
          user={this.props.user}
          postCount={getPostsCount(this.props.user)}
          followerCount={getFollowersCount(this.props.user)}
          followingCount={getFollowingCount(this.props.user)}
        />
      </div>
    );
  }

  render() {
    const { fields, children, contentFontClassName, borderWidth } = this.props;
    const { image, cover } = fields;
    const coverSrc = resolveUserImage(cover.value);
    const imageSrc = resolveUserImage(image.value);
    const cardClassName = classNames(
      styles.card,
      'forum-card-background-color',
      'forum-text-color',
      'forum-card-border-color'
    );

    return (
      <div className={classNames(styles.container, contentFontClassName, VIEW_CLASS_NAMES[this.props.view], 'profile')}>
        <div className={cardClassName} style={{ borderWidth }}>
          <div className={classNames(styles.cover, 'profile__cover')}>
            <ProfileCover src={coverSrc} isLoading={isDataUrl(coverSrc)}/>
            {this.renderUploadCoverButton()}
          </div>

          <div className={styles.photo}>
            <ProfilePhoto src={imageSrc} isLoading={isDataUrl(imageSrc)}/>
            {this.renderUploadPhotoButton()}
          </div>

          <div className={styles.flexContainer}>
            <div className={styles.userInfo}>
              <div className={classNames(styles.name, 'profile__name')}>
                {this.renderName()}
                {this.renderBadge()}
              </div>
              {this.renderJoinDate()}
            </div>

            <div className={styles.childrenContainer}>
              {children}
            </div>

            {this.renderStats()}
          </div>
        </div>
      </div>
    );
  }
}

Profile.defaultProps = {
  view: VIEW_PROFILE,
};

Profile.propTypes = {
  user: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  borderWidth: PropTypes.number.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  onCoverChange: PropTypes.func,
  buttonClicked: PropTypes.func,
  onImageChange: PropTypes.func,
  children: PropTypes.node,
  view: PropTypes.string,
  t: PropTypes.func,
};

const mapDispatchToProps = {
  buttonClicked,
};

export default flowRight(
  reduxForm(profileFormSettings), // reduxForm should be exposed
  connect(undefined, mapDispatchToProps),
  withCardBorderWidth,
  withFontClassName,
  withTranslate
)(Profile);



// WEBPACK FOOTER //
// ./app/components/profile/profile.js